import * as requests from '@cbgms/api/modules/concepts/requests'
import { IPaginatedRequest } from '@cbgms/api/request'

import * as types from './types'
import {
  GETConceptResponse,
  POSTConceptBody,
  POSTShopConceptBody,
  PUTConceptBody,
  PUTConceptResponse,
  PUTShopConceptBody
} from '@cbgms/api/modules/concepts'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const listConcepts = (params: IPaginatedRequest) => ({
  type: [types.GET_CONCEPTS, types.GET_CONCEPTS_SUCCESS, types.GET_CONCEPTS_FAILED],
  payload: {
    api: 'support',
    request: requests.listConcepts(params)
  }
})

export const getConcept = (UUID: string) =>
  AsyncAction<GETConceptResponse>({
    type: [types.GET_CONCEPT, types.GET_CONCEPT_SUCCESS, types.GET_CONCEPT_FAILED],
    payload: {
      api: 'support',
      request: requests.getConcept(UUID)
    }
  })

export const createConcept = (data: POSTConceptBody) => ({
  type: [types.CREATE_CONCEPT, types.CREATE_CONCEPT_SUCCESS, types.CREATE_CONCEPT_FAILED],
  payload: {
    api: 'support',
    request: requests.createConcept(data)
  }
})

export const updateConcept = (UUID: string, data: PUTConceptBody) =>
  AsyncAction<PUTConceptResponse>({
    type: [types.UPDATE_CONCEPT, types.UPDATE_CONCEPT_SUCCESS, types.UPDATE_CONCEPT_FAILED],
    payload: {
      api: 'support',
      request: requests.updateConcept(UUID, data)
    }
  })

export const listShopConcepts = (shopUUID: string, params: IPaginatedRequest) => ({
  type: [types.GET_SHOP_CONCEPTS, types.GET_SHOP_CONCEPTS_SUCCESS, types.GET_SHOP_CONCEPTS_FAILED],
  payload: {
    api: 'support',
    request: requests.listShopConcepts(shopUUID, params)
  }
})
export const createShopConcept = (shopUUID: string, data: POSTShopConceptBody) => ({
  type: [types.CREATE_SHOP_CONCEPT, types.CREATE_SHOP_CONCEPT_SUCCESS, types.CREATE_SHOP_CONCEPT_FAILED],
  payload: {
    api: 'support',
    request: requests.createShopConcept(shopUUID, data)
  }
})

export const updateShopConcept = (shopUUID: string, UUID: string, data: PUTShopConceptBody) => ({
  type: [types.UPDATE_SHOP_CONCEPT, types.UPDATE_SHOP_CONCEPT_SUCCESS, types.UPDATE_SHOP_CONCEPT_FAILED],
  payload: {
    api: 'support',
    request: requests.updateShopConcept(shopUUID, UUID, data)
  }
})

export const getConceptParticipants = (conceptUUID: string, params: IPaginatedRequest) =>
  AsyncAction<Blob>({
    type: [types.GET_CONCEPT_PARTICIPANTS, types.GET_CONCEPT_PARTICIPANTS_SUCCESS, types.GET_CONCEPT_PARTICIPANTS_FAILED],
    payload: {
      api: 'support',
      request: requests.getConceptParticipants(conceptUUID, params)
    }
  })
